import React, { Component } from "react";
import "./../css/master.css";
import "./../css/buyerDispatch.css";
import Header from "./../js/header.js";
import axiosInstance from "../api/csAxios";
import $ from "jquery";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ReactImageMagnify from "react-image-magnify";
import DatePicker from "react-datepicker";

var httpURL = "";
var queryString = require("querystring");
var lstDispatch = [];
var totalBalance = 0;
var quantity = 0;
var length = 0;

class BuyerDispatch extends Component {
  constructor(props) {
    super(props);
    this.state = {
      designImagePath: require("./../images/blank.png"),
      loader: "none",
      opacity: 1,
      dispatch: [],
      flg: true,
      width1: "97%",
      dispatchDate: null,
      totalQuantity: 0,
      quantityColor: "",
      minDate: null,
    };
  }

  handleDispatch = (date) => {
    var date1 = new Date();
    date1.setMonth(date1.getMonth() - 3);
    this.setState({
      dispatchDate: date,
      minDate: new Date(date1),
    });
  };

  async componentWillUnmount() {
    await localStorage.removeItem("buyerDispatch");
  }

  async componentDidMount() {
    $("#undoCompleted").addClass("disabled");
    var detail = await localStorage.getItem("buyerDispatch");
    console.log(detail);
    var details = JSON.parse(detail);
    var date = new Date();
    date.setMonth(date.getMonth() - 3);

    await this.setState({
      minDate: new Date(date),
    });

    var width = details.width;
    length = details.length;
    var lengthWidth = length + "/" + width;

    $("#ipoId").val(details.ipoId);
    $("#ipoNo").val(details.ipoNo);
    $("#bpoId").val(details.bpoId);
    $("#bpoNo").val(details.bpoNo);
    $("#ipoDesignId").val(details.ipoDesignId);
    $("#designId").val(details.designId);
    $("#designNoColor").val(details.designNoColor);
    $("#bpoStyleId").val(details.bpoStyleId);
    $("#styleColor").val(details.style + "-" + details.color);
    $("#quality").val(details.quality);
    $("#lengthWidth").val(lengthWidth);
    $("#yarnCount").val(details.yarnCount);
    $("#construction").val(details.construction);
    $("#deliveryDt").val(details.deliveryDt);

    this.setState({
      designImagePath: details.imageUrl,
    });
    this.dispatchFunction();
    this.handleResize();

    window.addEventListener("load", this.handleResize);
    window.addEventListener("resize", this.handleResize);
  }

  handleResize = () => {
    var width1 = $(".tableLayout1").parent().width() - 17;
    this.setState({ width1: width1 });
  };

  async dispatchFunction() {
    this.setState({ loader: "block", opacity: 0.5 });
    await axiosInstance({
      url: httpURL + "/a/bpo/disp/listdispatch",
      method: "POST",
      params: { bpoStyleId: parseInt($("#bpoStyleId").val()) },
      withCredentials: true,
    })
      .then((response) => {
        if (response.data.SvcStatus === "Success") {
          this.setState({
            dispatch: response.data.lstDispatch,
            totalQuantity: response.data.totalQuantity,
            quantityColor:
              $("#length").val() > response.data.totalQuantity
                ? "red"
                : "green",
          });
          $("#order_completed").prop("checked", response.data.orderCompleted);
          quantity = this.state.totalQuantity;
          totalBalance = response.data.totalBalance;
          if (response.data.orderCompleted == true) {
            $("#newDispatchForm input, button").attr("disabled", true);
            $("#resend").attr("disabled", true);
            $("#undoCompleted").removeClass("disabled");
          } else {
            $("#undoCompleted").addClass("disabled");
          }
          lstDispatch = this.state.dispatch;

          this.setDispatchTable();
        } else {
          toast.error(response.data.SvcMsg);
          if (
            response.data.SvcMsg == "No Dispatch Data exist for this BPO Design"
          ) {
            lstDispatch = [];
            this.setDispatchTable();
          }

          if (response.data.SvcMsg == "You are not logged in") {
            window.location.href = window.CSURL;
            return false;
          }
        }
        this.setState({ loader: "none", opacity: 1 });
      })
      .catch((error) => {
        toast.error("Service failed " + error);
      });
  }

  setDispatchTable = () => {
    $("#dispatchTbody tr").remove();
    var table = document.getElementById("dispatchTable");
    var tbody = document.getElementById("dispatchTbody");

    for (var i = 0; i < lstDispatch.length; i++) {
      var dispatchId = lstDispatch[i].styleDispatchId;
      var dispatchDt = lstDispatch[i].styleDispatchDt;
      var invoiceNo = lstDispatch[i].invoiceNo;
      var quantity = lstDispatch[i].quantity;
      var status = lstDispatch[i].status;
      var csSubmitDt = lstDispatch[i].csSubmitDt;

      var row = document.createElement("tr");
      row.dispatchId = dispatchId;
      row.onclick = (e) => {
        $(e.target).closest('tr').addClass("selected").siblings().removeClass("selected");
      };

      this.addTD(row, dispatchId, "text-right no-display");
      this.addTD(row, dispatchDt, "text-center");
      this.addTD(row, invoiceNo, "");
      this.addTD(row, quantity, "text-right");
      this.addTD(row, status, "");
      this.addTD(row, csSubmitDt, "text-center");
      this.addTDEdit(row, "glyphicon glyphicon-edit", "text-center");

      tbody.append(row);
    }
    table.append(tbody);
  };

  addTD(row, val, classname) {
    var cell = document.createElement("td");
    cell.className = classname;
    var text = document.createTextNode(val);
    cell.append(text);
    row.append(cell);
  }

  addTDEdit(row, val, classname) {
    var cell = document.createElement("td");
    cell.className = classname;
    var span = document.createElement("span");
    span.className = val;
    span.style.cursor = "pointer";
    span.title = "Edit Dispatch";
    span.style.width = "100%";
    span.onclick = () => {
      $("td").removeClass("selected");
      $(row).addClass("selected").siblings().removeClass("selected");
      var styleDispatchId = $("#dispatchTbody tr.selected")
        .find("td:eq(0)")
        .text();
      $("body").addClass("sliderOpen");
      this.setDispatchForm(styleDispatchId);
      this.setState({ flg: false });
      $(".popupForm").show();
    };
    cell.append(span);
    row.append(cell);
  }

  setDispatchForm = (id) => {
    var dispatchData = this.getDispatchData(id);
    if (dispatchData !== -1) {
      $("#inp_invoice1").val(dispatchData.invoiceNo);
      $("#inp_quantity1").val(dispatchData.quantity);

      var date = dispatchData.styleDispatchDt;
      date = date.split("-");
      var setDate = date.reverse().join();
      setDate = setDate.replace(/,/g, "-");
      var styleDispatchDt = new Date(setDate);
      this.setState({
        dispatchDate: styleDispatchDt,
      });
    }
  };

  getDispatchData(id) {
    for (var i = 0; i < lstDispatch.length; i++) {
      if (id == lstDispatch[i].styleDispatchId) {
        return lstDispatch[i];
      }
    }
    return -1;
  }
  resendDispatch = () => {
    var bpoStyleId = $("#bpoStyleId").val();
    axiosInstance
      .post(
        httpURL + "/a/bpo/disp/resend",
        queryString.stringify({ bpoStyleId: bpoStyleId }),
        { withCredentials: true }
      )
      .then((response) => {
        if (response.data.SvcStatus === "Success") {
          toast.success("Send Mail Successfully!");
        } else {
          toast.error(response.data.SvcMsg);
        }
      })
      .catch((error) => {
        toast.error(error);
      });
  };

  addDispatch = () => {
    var dispatch = {};
    var bpoStyleId = $("#bpoStyleId").val();
    var invoiceNo = $("#inp_invoice").val();
    var styleDispatchId = 0;
    var styleDispatchDt = $("#dispatchDt").val();
    var quantity = $("#inp_quantity").val();

    if (invoiceNo == "") {
      toast.warning("Please fill invoice number");
      return false;
    }

    if (styleDispatchDt == "") {
      toast.warning("Please fill dispatch date");
      return false;
    }

    if (quantity == "") {
      toast.warning("Please fill quantity");
      return false;
    }

    dispatch = {
      styleDispatchId,
      bpoStyleId,
      invoiceNo,
      styleDispatchDt,
      quantity,
    };

    this.setState({ loader: "block", opacity: 0.5 });
    axiosInstance
      .post(
        httpURL + "/a/bpo/disp/save",
        queryString.stringify({ dispatch: JSON.stringify(dispatch) }),
        { withCredentials: true }
      )
      .then((response) => {
        if (response.data.SvcStatus === "Success") {
          toast.success(response.data.SvcMsg);
          dispatch.styleDispatchId = response.data.styleDispatchId;
          dispatch.status = response.data.status;
          dispatch.csSubmitDt = response.data.csSubmitDt;
          lstDispatch.unshift(dispatch);
          this.setDispatchTable();
          $("#inp_invoice").val("");
          $("#dispatchDt").val("");
          $("#inp_quantity").val("");
          this.setState({
            dispatchDate: null,
            totalQuantity: response.data.totalQuantity,
            quantityColor:
              $("#length").val() > response.data.totalQuantity
                ? "red"
                : "green",
          });
          quantity = this.state.totalQuantity;
          totalBalance = response.data.totalBalance;
        } else {
          toast.error(response.data.SvcMsg);
          if (response.data.SvcMsg == "You are not logged in") {
            window.location.href = window.WVRURL;
            return false;
          }
        }
        this.setState({ loader: "none", opacity: 1 });
      })
      .catch((error) => {
        toast.error("Service failed " + error);
      });
  };

  editDispatch = () => {
    var dispatch = {};
    var bpoStyleId = $("#bpoStyleId").val();
    var invoiceNo = $("#inp_invoice1").val();
    var styleDispatchId = $("#dispatchTbody tr.selected")
      .find("td:eq(0)")
      .text();
    var styleDispatchDt = $("#dispatchDt").val();
    var quantity = $("#inp_quantity1").val();

    if (invoiceNo == "") {
      toast.warning("Please fill invoice number");
      return false;
    }

    if (styleDispatchDt == "") {
      toast.warning("Please fill dispatch date");
      return false;
    }

    if (quantity == "") {
      toast.warning("Please fill quantity");
      return false;
    }

    dispatch = {
      styleDispatchId,
      bpoStyleId,
      invoiceNo,
      styleDispatchDt,
      quantity,
    };

    this.setState({ loader: "block", opacity: 0.5 });
    axiosInstance
      .post(
        httpURL + "/a/bpo/disp/save",
        queryString.stringify({ dispatch: JSON.stringify(dispatch) }),
        { withCredentials: true }
      )
      .then((response) => {
        if (response.data.SvcStatus === "Success") {
          toast.success(response.data.SvcMsg);
          $(".popupForm").hide();
          $("body").removeClass("sliderOpen");
          this.dispatchFunction();
          $("#inp_invoice").val("");
          $("#dispatchDt").val("");
          $("#inp_quantity").val("");
          this.setState({
            dispatchDate: null,
            flg: true,
            totalQuantity: response.data.totalQuantity,
            quantityColor:
              $("#length").val() > response.data.totalQuantity
                ? "red"
                : "green",
          });
          quantity = this.state.totalQuantity;
          totalBalance = response.data.totalBalance;
        } else {
          toast.error(response.data.SvcMsg);
          if (response.data.SvcMsg == "You are not logged in") {
            window.location.href = window.WVRURL;
            return false;
          }
        }
        this.setState({ loader: "none", opacity: 1 });
      })
      .catch((error) => {
        toast.error("Service failed " + error);
      });
  };

  orderCompleted = (e) => {
    var bpoStyleId = $("#bpoStyleId").val();
    if ($(e.target).prop("checked")) {
      this.setState({ loader: "block", opacity: 0.5 });
      axiosInstance
        .post(
          httpURL + "/a/bpo/disp/changeorder",
          queryString.stringify({ bpoStyleId: bpoStyleId }),
          { withCredentials: true }
        )
        .then((response) => {
          if (response.data.SvcStatus === "Success") {
            toast.success(response.data.SvcMsg);
            $("#newDispatchForm input, button").attr("disabled", true);
            $("#resend").attr("disabled", true);
            $("#undoCompleted").removeClass("disabled");
          } else {
            toast.error(response.data.SvcMsg);
            if (response.data.SvcMsg == "You are not logged in") {
              window.location.href = window.CSURL;
              return false;
            }
            $("#order_completed").prop("checked", false);
          }
          this.setState({ loader: "none", opacity: 1 });
        })
        .catch((error) => {
          toast.error("Service failed " + error);
        });
    }
  };
  undoCompleted = () => {
    var retVal = window.confirm("Do you want to undo Completed ?");
    if (retVal == true) {
      this.undoComplete();
      return true;
    } else {
      return false;
    }
  };

  undoComplete = () => {
    var bpoStyleId = $("#bpoStyleId").val();
    if ($("#order_completed").prop("checked")) {
      this.setState({ loader: "block", opacity: 0.5 });
      axiosInstance
        .post(
          httpURL + "/a/bpo/disp/undocompleted",
          queryString.stringify({ bpoStyleId: bpoStyleId }),
          { withCredentials: true }
        )
        .then((response) => {
          if (response.data.SvcStatus === "Success") {
            toast.success(response.data.SvcMsg);
            $("#newDispatchForm input, button").attr("disabled", false);
            $("#resend").attr("disabled", false);
            $("#order_completed").prop("checked", false);
            $("#undoCompleted").addClass("disabled");
          } else {
            toast.error(response.data.SvcMsg);
            if (response.data.SvcMsg == "You are not logged in") {
              window.location.href = window.CSURL;
              return false;
            }
            $("#order_completed").prop("checked", false);
          }
          this.setState({ loader: "none", opacity: 1 });
        })
        .catch((error) => {
          toast.error("Service failed " + error);
        });
    }
  };
  hideSlider = () => {
    $(".popupForm").hide();
    $("body").removeClass("sliderOpen");
    this.setState({
      dispatchDate: null,
    });
  };

  maintainDispatch = () => {
    if (this.state.flg) {
      this.addDispatch();
    } else {
      this.editDispatch();
    }
  };

  render() {
    httpURL = window.httpURL;
    return (
      <div style={{ height: "100%" }}>
        <Header />
        <ToastContainer autoClose={2000} hideProgressBar />
        <div
          style={{
            position: "fixed",
            width: 100,
            height: 100,
            marginLeft: -50,
            marginTop: -50,
            left: "50%",
            top: "50%",
            display: this.state.loader,
            zIndex: 9999,
          }}
        >
          <img src={require("../images/loader.gif")} alt="Loader..." />
        </div>
        <div
          className="main buyerDispatchWrapper"
          style={{ opacity: this.state.opacity }}
        >
          <div className="container-fluid">
            <div className="col-sm-12 col-centered">
              <div className="row">
                <div className="col-sm-10" style={{ paddingLeft: 0 }}>
                  <div className="styleBackground">
                    <form className="form-inline">
                      <div className="form-group">
                        <label style={{ width: 102 }} htmlFor="ipoNo">
                          IPO NO:
                        </label>
                        <input
                          style={{ display: "none" }}
                          placeholder="IPO Id"
                          type="text"
                          className="form-control"
                          id="ipoId"
                        />
                        <input
                          style={{ display: "none" }}
                          placeholder="IPO Design Id"
                          type="text"
                          className="form-control"
                          id="ipoDesignId"
                        />
                        <input
                          style={{ marginLeft: 2 }}
                          readOnly
                          placeholder="IPO Number"
                          type="text"
                          className="form-control"
                          id="ipoNo"
                        />
                      </div>
                      <div className="form-group">
                        <label
                          style={{ marginLeft: 10, width: 102 }}
                          htmlFor="bpoNo"
                        >
                          BPO NO:
                        </label>
                        <input
                          style={{ display: "none" }}
                          placeholder="BPO Id"
                          type="text"
                          className="form-control"
                          id="bpoId"
                        />
                        <input
                          style={{ marginLeft: 2 }}
                          readOnly
                          placeholder="BPO Number"
                          type="text"
                          className="form-control"
                          id="bpoNo"
                        />
                      </div>
                      <div className="form-group">
                        <label
                          style={{ marginLeft: 10, width: 102 }}
                          htmlFor="designNoColor"
                        >
                          Design Color:
                        </label>
                        <input
                          style={{ display: "none" }}
                          placeholder="Design Id"
                          type="text"
                          className="form-control"
                          id="designId"
                        />
                        <input
                          style={{ marginLeft: 2 }}
                          readOnly
                          placeholder="Design Color"
                          type="text"
                          className="form-control"
                          id="designNoColor"
                        />
                      </div>
                    </form>
                    <form className="form-inline" style={{ marginTop: 5 }}>
                      <div className="form-group">
                        <label style={{ width: 102 }} htmlFor="quality">
                          Quality:
                        </label>
                        <input
                          style={{ marginLeft: 2 }}
                          readOnly
                          placeholder="Quality"
                          type="text"
                          className="form-control"
                          id="quality"
                        />
                      </div>
                      <div className="form-group">
                        <label
                          style={{ marginLeft: 10, width: 102 }}
                          htmlFor="length"
                        >
                          Length / Width:
                        </label>
                        <input
                          style={{ marginLeft: 2 }}
                          readOnly
                          placeholder="Length / Width"
                          type="text"
                          className="form-control text-right"
                          id="lengthWidth"
                        />
                      </div>
                      <div className="form-group">
                        <label
                          style={{ marginLeft: 10, width: 102 }}
                          htmlFor="deliveryDt"
                        >
                          Delivery Dt:
                        </label>
                        <input
                          style={{ marginLeft: 2 }}
                          readOnly
                          placeholder="Delivery Date"
                          type="text"
                          className="form-control"
                          id="deliveryDt"
                        />
                      </div>
                    </form>
                    <form className="form-inline" style={{ marginTop: 5 }}>
                      <div className="form-group">
                        <label style={{ width: 102 }} htmlFor="yarnCount">
                          Yarn Count:
                        </label>
                        <input
                          style={{ marginLeft: 2 }}
                          readOnly
                          placeholder="Yarn Count"
                          type="text"
                          className="form-control"
                          id="yarnCount"
                        />
                      </div>
                      <div className="form-group">
                        <label
                          style={{ marginLeft: 10, width: 102 }}
                          htmlFor="construction"
                        >
                          Construction:
                        </label>
                        <input
                          style={{ marginLeft: 2 }}
                          readOnly
                          placeholder="Construction"
                          type="text"
                          className="form-control"
                          id="construction"
                        />
                      </div>
                      <div className="form-group">
                        <label
                          style={{ marginLeft: 10, width: 102 }}
                          htmlFor="styleColor"
                        >
                          Style-Color:
                        </label>
                        <input
                          style={{ display: "none" }}
                          placeholder="Style Id"
                          type="text"
                          className="form-control"
                          id="bpoStyleId"
                        />
                        <input
                          style={{ marginLeft: 2 }}
                          readOnly
                          placeholder="Style-Color"
                          type="text"
                          className="form-control"
                          id="styleColor"
                        />
                        <button
                          style={{ marginLeft: 85 }}
                          onClick={this.resendDispatch}
                          type="button"
                          className="btn btn-warning"
                          id="resend"
                        >
                          Resend Mail
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
                <div
                  className="col-sm-2 padding-remove"
                  id="designColorImageDivBuyerDispatch"
                >
                  <ReactImageMagnify
                    {...{
                      smallImage: {
                        alt: "Design Image",
                        src: this.state.designImagePath,
                        isFluidWidth: true,
                      },
                      largeImage: {
                        src: this.state.designImagePath,
                        width: 600,
                        height: 900,
                      },
                      enlargedImageContainerDimensions: {
                        width: 300,
                        height: 300,
                      },
                      enlargedImageContainerStyle: {
                        left: -185,
                        top: 125,
                        zIndex: 999,
                      },
                    }}
                  />
                </div>
              </div>
              <div className="row">
                <div
                  style={{
                    marginTop: 5,
                    display: "flex",
                    flexDirection: "row",
                    position: "relative",
                  }}
                  className="styleBackground"
                >
                  <h4
                    style={{ fontWeight: "bold", color: "#bb592b", width: 150 }}
                  >
                    New Dispatch
                  </h4>
                  <form className="form-inline" id="newDispatchForm">
                    <div className="form-group">
                      <label style={{ width: 100 }} htmlFor="inp_invoice">
                        Invoice No.:<span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        type="text"
                        id="inp_invoice"
                        placeholder="Invoice No."
                        className="form-control"
                      />
                    </div>
                    <div style={{ marginLeft: 20 }} className="form-group">
                      <label style={{ width: 120 }} htmlFor="dispatchDt">
                        Dispatch Date:<span style={{ color: "red" }}>*</span>
                      </label>
                      <div style={{ display: "inline-block", width: 120 }}>
                        <DatePicker
                          id="dispatchDt"
                          className="form-control inline-width text-center"
                          placeholderText="Dispatch Date"
                          selected={this.state.dispatchDate}
                          onChange={this.handleDispatch}
                          dateFormat="dd-MM-yyyy"
                          autoComplete="off"
                          //minDate={this.state.minDate}
                        />
                      </div>
                    </div>
                    <div style={{ marginLeft: 20 }} className="form-group">
                      <label style={{ width: 80 }} htmlFor="inp_quantity">
                        Quantity:<span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        style={{ marginLeft: 2, width: 120 }}
                        type="text"
                        id="inp_quantity"
                        placeholder="Quantity"
                        className="form-control text-right"
                      />
                    </div>
                    <button
                      style={{ marginLeft: 10 }}
                      onClick={this.maintainDispatch}
                      type="button"
                      className="btn btn-warning"
                    >
                      Save
                    </button>
                    <div
                      className="form-group completedWrap"
                      style={{ position: "absolute", right: 10, top: 10 }}
                    >
                      <span
                        id="undoCompleted"
                        title="Undo Completed"
                        className="undoCompleted"
                        onClick={this.undoCompleted}
                      >
                        {" "}
                        Undo Completed{" "}
                      </span>
                      <label htmlFor="">Order Completed:</label>
                      <div className="checkbox" style={{ marginLeft: 5 }}>
                        <input
                          onChange={this.orderCompleted}
                          type="checkbox"
                          id="order_completed"
                        />
                      </div>
                    </div>
                  </form>
                </div>
              </div>
              <div className="row" style={{ marginTop: 5 }}>
                <table
                  className="tableLayout1"
                  style={{ width: this.state.width1 }}
                >
                  <thead>
                    <tr>
                      <th style={{ width: 100, display: "none" }}>
                        Dispatch Id
                      </th>
                      <th style={{ width: 100 }}>Dispatch Date</th>
                      <th style={{ width: 100 }}>Invoice No. </th>
                      <th style={{ width: 100 }}>Quantity</th>
                      <th style={{ width: 100 }}>Buyer Status</th>
                      <th style={{ width: 100 }}>Submit Date</th>
                      <th style={{ width: 100 }}>Action</th>
                    </tr>
                  </thead>
                </table>
                <div style={{ height: 250, overflowY: "scroll" }}>
                  <table className="tableLayout" id="dispatchTable">
                    <colgroup>
                      <col style={{ width: 100 }} />
                      <col style={{ width: 100 }} />
                      <col style={{ width: 100 }} />
                      <col style={{ width: 100 }} />
                      <col style={{ width: 100 }} />
                      <col style={{ width: 100 }} />
                    </colgroup>
                    <tbody id="dispatchTbody"></tbody>
                  </table>
                </div>
              </div>

              <div
                className="row text-right"
                style={{ marginTop: 20, marginRight: 0 }}
              >
                <span
                  className="digitalFont"
                  style={{
                    fontSize: 20,
                    fontWeight: "bold",
                    color: this.state.quantityColor,
                  }}
                >
                  Total Quantity: {this.state.totalQuantity}
                </span>
              </div>
              <div
                className="row text-right"
                style={{ marginTop: 10, marginRight: 0 }}
              >
                <span
                  className="digitalFont"
                  style={{ fontSize: 20, fontWeight: "bold", color: "black" }}
                >
                  Total Balance: {totalBalance}
                </span>
              </div>

              <div className="row popupForm">
                <div className="styleBackground1">
                  <h4 style={{ fontWeight: "bold", color: "#bb592b" }}>
                    Edit Dispatch
                  </h4>
                  <form className="form-horizontal" id="newDispatchForm1">
                    <div className="form-group">
                      <label className="col-sm-5" htmlFor="inp_invoice">
                        Invoice No.:<span style={{ color: "red" }}>*</span>
                      </label>
                      <div className="col-sm-6">
                        <input
                          type="text"
                          id="inp_invoice1"
                          placeholder="Invoice No."
                          className="form-control "
                        />
                      </div>
                    </div>
                    <div className="form-group">
                      <label className="col-sm-5" htmlFor="dispatchDt">
                        Dispatch Date:<span style={{ color: "red" }}>*</span>
                      </label>
                      <div
                        style={{ display: "inline-block" }}
                        className="col-sm-6"
                      >
                        <DatePicker
                          id="dispatchDt"
                          className="form-control inline-width text-center"
                          placeholderText="Dispatch Date"
                          selected={this.state.dispatchDate}
                          onChange={this.handleDispatch}
                          dateFormat="dd-MM-yyyy"
                          autoComplete="off"
                          //minDate={this.state.minDate}
                        />
                      </div>
                    </div>
                    <div className="form-group">
                      <label className="col-sm-5" htmlFor="inp_quantity">
                        Quantity:<span style={{ color: "red" }}>*</span>
                      </label>
                      <div className="col-sm-6">
                        <input
                          type="text"
                          id="inp_quantity1"
                          placeholder="Quantity"
                          className="form-control text-right"
                        />
                      </div>
                    </div>
                    <div className="buttonWrap">
                      <button
                        style={{ marginTop: 20 }}
                        onClick={this.maintainDispatch}
                        type="button"
                        className="btn btn-warning"
                      >
                        Save
                      </button>
                    </div>
                    <span
                      className="cd-panel-close glyphicon glyphicon-remove"
                      onClick={this.hideSlider}
                    >
                      Close
                    </span>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default BuyerDispatch;
